export default {
  vuetifyTheme: {
    primary: '#eab80e',
    secondary: {
      base: '#A6A6A6',
      lighten1: '#D1D1D1',
      lighten2: '#E8E8E8',
      darken1: '#7A7A7A',
      darken2: '#4F4F4F',
    },
    error: {
      base: '#D0021B',
      lighten1: '#DE3C23',
      lighten2: '#EB5E49',
      darken1: '#AB0215',
      darken2: '#850111',
    },
    success: '#5F9400',
    warning: '#FFC356',
  },
  componentDefaults: {
    VTextField: {
      outlined: true,
    },
    VBtn: {
      color: 'primary',
    },
  },
}
